var _mask, _path, _path2, _path3, _path4, _path5, _g, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinToDrapDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 114,
    viewBox: "0 0 188 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_0_1",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 188,
    height: 54,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 188,
    height: 54
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V39C1 42.3137 3.6863 45 7.00001 45H85.5835L92.8907 52.0204C93.2777 52.3923 93.8893 52.3923 94.2763 52.0204L101.583 45H181C184.314 45 187 42.3137 187 39V7C187 3.68629 184.314 1 181 1H7Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V39C1 42.3137 3.6863 45 7.00001 45H85.5835L92.8907 52.0204C93.2777 52.3923 93.8893 52.3923 94.2763 52.0204L101.583 45H181C184.314 45 187 42.3137 187 39V7C187 3.68629 184.314 1 181 1H7Z",
    fill: "#FFDD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5835 45L86.2764 44.2789L85.9861 44H85.5835V45ZM92.8907 52.0204L92.1979 52.7415V52.7415L92.8907 52.0204ZM94.2763 52.0204L94.9691 52.7415V52.7415L94.2763 52.0204ZM101.583 45V44H101.181L100.891 44.2789L101.583 45ZM2 7C2 4.23858 4.23858 2 7 2V0C3.13401 0 0 3.13401 0 7H2ZM2 39V7H0V39H2ZM7.00001 44C4.23858 44 2 41.7614 2 39H0C0 42.866 3.13401 46 7.00001 46V44ZM85.5835 44H7.00001V46H85.5835V44ZM84.8907 45.7211L92.1979 52.7415L93.5835 51.2993L86.2764 44.2789L84.8907 45.7211ZM92.1979 52.7415C92.9719 53.4852 94.1951 53.4852 94.9691 52.7415L93.5835 51.2993L92.1979 52.7415ZM94.9691 52.7415L102.276 45.7211L100.891 44.2789L93.5835 51.2993L94.9691 52.7415ZM181 44H101.583V46H181V44ZM186 39C186 41.7614 183.761 44 181 44V46C184.866 46 188 42.866 188 39H186ZM186 7V39H188V7H186ZM181 2C183.761 2 186 4.23858 186 7H188C188 3.13401 184.866 0 181 0V2ZM7 2H181V0H7V2Z",
    fill: "white",
    mask: "url(#path-1-outside-1_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6452 113.355C98.2083 113.355 101.097 110.466 101.097 106.903C101.097 103.34 98.2083 100.452 94.6452 100.452C91.0821 100.452 88.1936 103.34 88.1936 106.903C88.1936 110.466 91.0821 113.355 94.6452 113.355Z",
    fill: "#A1A1A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6451 110.774C96.783 110.774 98.5161 109.041 98.5161 106.903C98.5161 104.765 96.783 103.032 94.6451 103.032C92.5073 103.032 90.7742 104.765 90.7742 106.903C90.7742 109.041 92.5073 110.774 94.6451 110.774Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6451 82.3871C93.9324 82.3871 93.3547 82.9648 93.3547 83.6774V106.903C93.3547 107.616 93.9324 108.194 94.6451 108.194C95.3577 108.194 95.9354 107.616 95.9354 106.903V83.6774C95.9354 82.9648 95.3577 82.3871 94.6451 82.3871Z",
    fill: "#A1A1A1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0001 92.7097C104.689 92.7097 113.355 84.0442 113.355 73.3548C113.355 62.6655 104.689 54 94.0001 54C83.3107 54 74.6453 62.6655 74.6453 73.3548C74.6453 84.0442 83.3107 92.7097 94.0001 92.7097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.664 73.3548C112.664 83.6625 104.308 92.0184 94.0001 92.0184C83.6925 92.0184 75.3365 83.6625 75.3365 73.3548C75.3365 63.0472 83.6925 54.6912 94.0001 54.6912C104.308 54.6912 112.664 63.0472 112.664 73.3548Z",
    stroke: "#DBDBDB",
    strokeWidth: 1.38249
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 88.8387C102.551 88.8387 109.484 81.9063 109.484 73.3548C109.484 64.8033 102.551 57.871 94 57.871C85.4485 57.871 78.5161 64.8033 78.5161 73.3548C78.5161 81.9063 85.4485 88.8387 94 88.8387Z",
    fill: "#FFDD00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 60.4517,
    y: 42.3871,
    width: 67.0968,
    height: 67.0968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.58065
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.09677
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinToDrapDrop);
export default __webpack_public_path__ + "static/media/pin-to-drap-drop.2505c16d52943d3804514db563dc5705.svg";
export { ForwardRef as ReactComponent };